export default {
  install(app) {
    const workerMap = new Map()

    function getWorker(orgId) {
      if (!workerMap.has(orgId)) {
        let url = new URL('/static/pusher.worker.js', import.meta.url)
        console.debug(`[Pusher:plugin] creating SharedWorker for org ${orgId}`, url.href)
        const worker = new SharedWorker(url)
        worker.port.start()
        workerMap.set(orgId, worker)
      }
      return workerMap.get(orgId)
    }

    app.config.globalProperties.$subscribePusher = (config, handler) => {
      console.debug(`[Pusher:plugin] subscribe orgId=${config.orgId}`)
      try {
        const worker = getWorker(config.orgId)
        function listener(event) {
          const { orgId: o, event: evt, data } = event.data
          console.debug(`[Pusher:plugin] received ${evt} for org ${o}`)
          if (o === config.orgId) handler(evt, data)
        }

        worker.port.addEventListener('message', listener)
        worker.port.postMessage({ action: 'subscribe', config })

        return () => {
          console.debug(`[Pusher:plugin] unsubscribe orgId=${config.orgId}`)
          worker.port.postMessage({
            action: 'unsubscribe',
            orgId: config.orgId,
          })
          worker.port.removeEventListener('message', listener)
        }
      } catch (err) {
        console.info("Pusher probably won't work on this platform", err)
      }
    }
  },
}
